/**
 * Formati che dipendono dalla lingua: elenchi, plurali, numeri.
 *
 * Vivono fuori dal traduttore perché servono ai cataloghi stessi: una voce che
 * nomina «web, worker e db» deve unire i nomi con la congiunzione della propria
 * lingua, e non può chiedere al traduttore che la sta leggendo.
 */

export function formati(lingua: string) {
  const elenchi = new Intl.ListFormat(lingua, { type: "conjunction" });
  const plurali = new Intl.PluralRules(lingua);
  const numeri = new Intl.NumberFormat(lingua);

  return {
    elenco: (voci: readonly string[]): string => elenchi.format(voci),
    plurale: (n: number, forme: { one: string; other: string }): string =>
      plurali.select(n) === "one" ? forme.one : forme.other,
    numero: (n: number): string => numeri.format(n),
  };
}
